/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class LayerApi extends runtime.BaseAPI {
    /**
     * Create Map Layer
     */
    async v2CreateMapLayerRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling v2CreateMapLayer().');
        }
        if (requestParameters['mapId'] == null) {
            throw new runtime.RequiredError('mapId', 'Required parameter "mapId" was null or undefined when calling v2CreateMapLayer().');
        }
        if (requestParameters['layerIn'] == null) {
            throw new runtime.RequiredError('layerIn', 'Required parameter "layerIn" was null or undefined when calling v2CreateMapLayer().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/layer/{profile_id}/map/{map_id}`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        urlPath = urlPath.replace(`{${"map_id"}}`, encodeURIComponent(String(requestParameters['mapId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['layerIn'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Map Layer
     */
    async v2CreateMapLayer(requestParameters, initOverrides) {
        const response = await this.v2CreateMapLayerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create Map Layers
     */
    async v2CreateMapLayersRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling v2CreateMapLayers().');
        }
        if (requestParameters['mapId'] == null) {
            throw new runtime.RequiredError('mapId', 'Required parameter "mapId" was null or undefined when calling v2CreateMapLayers().');
        }
        if (requestParameters['v2CreateMapLayersRequestInner'] == null) {
            throw new runtime.RequiredError('v2CreateMapLayersRequestInner', 'Required parameter "v2CreateMapLayersRequestInner" was null or undefined when calling v2CreateMapLayers().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/layermulti/{profile_id}/map/{map_id}/`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        urlPath = urlPath.replace(`{${"map_id"}}`, encodeURIComponent(String(requestParameters['mapId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['v2CreateMapLayersRequestInner'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Map Layers
     */
    async v2CreateMapLayers(requestParameters, initOverrides) {
        const response = await this.v2CreateMapLayersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Layer
     */
    async v2DeleteLayerRaw(requestParameters, initOverrides) {
        if (requestParameters['layerId'] == null) {
            throw new runtime.RequiredError('layerId', 'Required parameter "layerId" was null or undefined when calling v2DeleteLayer().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/layer/{layer_id}`;
        urlPath = urlPath.replace(`{${"layer_id"}}`, encodeURIComponent(String(requestParameters['layerId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Delete Layer
     */
    async v2DeleteLayer(requestParameters, initOverrides) {
        const response = await this.v2DeleteLayerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Layer
     */
    async v2GetLayerRaw(requestParameters, initOverrides) {
        if (requestParameters['layerId'] == null) {
            throw new runtime.RequiredError('layerId', 'Required parameter "layerId" was null or undefined when calling v2GetLayer().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/layer/{layer_id}`;
        urlPath = urlPath.replace(`{${"layer_id"}}`, encodeURIComponent(String(requestParameters['layerId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Layer
     */
    async v2GetLayer(requestParameters, initOverrides) {
        const response = await this.v2GetLayerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Map Layers
     */
    async v2GetMapLayersRaw(requestParameters, initOverrides) {
        if (requestParameters['mapId'] == null) {
            throw new runtime.RequiredError('mapId', 'Required parameter "mapId" was null or undefined when calling v2GetMapLayers().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/layer/map/{map_id}/`;
        urlPath = urlPath.replace(`{${"map_id"}}`, encodeURIComponent(String(requestParameters['mapId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Map Layers
     */
    async v2GetMapLayers(requestParameters, initOverrides) {
        const response = await this.v2GetMapLayersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update Layer
     */
    async v2UpdateLayerRaw(requestParameters, initOverrides) {
        if (requestParameters['layerId'] == null) {
            throw new runtime.RequiredError('layerId', 'Required parameter "layerId" was null or undefined when calling v2UpdateLayer().');
        }
        if (requestParameters['layerIn1'] == null) {
            throw new runtime.RequiredError('layerIn1', 'Required parameter "layerIn1" was null or undefined when calling v2UpdateLayer().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/layer/{layer_id}`;
        urlPath = urlPath.replace(`{${"layer_id"}}`, encodeURIComponent(String(requestParameters['layerId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['layerIn1'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update Layer
     */
    async v2UpdateLayer(requestParameters, initOverrides) {
        const response = await this.v2UpdateLayerRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
